import { Controller } from "@hotwired/stimulus"
import $ from "jquery";
import { set } from "lodash";
import "select2"
let hideTimeout;
// Connects to data-controller="activation-wizard"
export default class extends Controller {
  static targets = [
    "continueBtn",
    "roleDescriptionContainer",
    "welcomeDescriptionContainer",
    "roleAdminContainer",
    "userSelect",
    'tooltip',
    'triggerElement'
  ]
  static values = { maximumCount: Number }

  connect() {
    this.checkRequiredFields()
    this.initializeSelect2()
    this.updateRoleUserCounter() 
    this.isHoveringTrigger = false;
    this.isHoveringDescription = false;
    this.currentDescriptionTarget = null;
    this.isMouseInside = false;

    // Attach document click handler for dropdown close
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  // === Original methods ===
  closeModal() { window.location.href = "/educator_dashboard" }

  assignDeans() {
    console.log("assignDeans clicked! Redirecting...")
    window.location.href = "/activation_wizard/curriculum_admin"
  }

  toggleRoleDescription() {
    console.log("Toggling role description visibility")
    this.roleDescriptionContainerTarget.classList.toggle("d-none")
  }

  toggleWelcomeDescription() {
    console.log("Toggling welcome description visibility")
    this.welcomeDescriptionContainerTarget.classList.toggle("d-none")
  }

  showDescription(event) {
    const targetElement = event.currentTarget.getAttribute('data-activation-wizard-description-target');
    if (!targetElement || !this[`${targetElement}Target`]) {
      console.warn(`Target "${targetElement}" not found or not specified`);
      return;
    }

    const targetContainer = this[`${targetElement}Target`];

    // Show the description
    targetContainer.classList.remove('d-none');

    // Store the current target for reference
    this.currentDescriptionTarget = targetElement;
  }

  // Flag that we're hovering over the description itself
  keepDescriptionVisible(event) {
    this.isHoveringDescription = true;
  }

  startHideDescription(event) {
    this.isHoveringDescription = false;

    // Get the target from the container
    const targetContainer = event.currentTarget;

    // Small delay to allow for mouse movement between elements
    setTimeout(() => {
      if (!this.isHoveringDescription && !this.isHoveringTrigger) {
        targetContainer.classList.add('d-none');
      }
    }, 100);
  }

  // Check if we should hide when leaving the trigger
  maybeHideDescription(event) {
    this.isHoveringTrigger = false;

    const targetElement = event.currentTarget.getAttribute('data-activation-wizard-description-target');
    if (!targetElement || !this[`${targetElement}Target`]) return;

    const targetContainer = this[`${targetElement}Target`];

    // Small delay to allow for mouse movement between elements
    setTimeout(() => {
      if (!this.isHoveringDescription && !this.isHoveringTrigger) {
        targetContainer.classList.add('d-none');
      }
    }, 100);
  }

  handleMouseEnter() {
    // Cancel any hide timeout
    clearTimeout(hideTimeout);

    // Show tooltip
    this.tooltipTarget.classList.remove('d-none');
    this.isMouseInside = true;
  }

  handleMouseLeave() {
    this.isMouseInside = false;

    // Delay hiding to allow for hover into tooltip
    hideTimeout = setTimeout(() => {
      if (!this.isMouseInside) {
        this.tooltipTarget.classList.add('d-none');
      }
    }, 500); // 1 second delay
  }

  handleHover(event) {
    // Get the target container from the event's current target's data attribute
    const targetElement = event.currentTarget.getAttribute('data-activation-wizard-description-target');

    if (!targetElement) {
      console.warn("No target specified for hover action");
      return;
    }

    // Check if the target exists using the Stimulus targets API
    const targetName = `${targetElement}Target`;

    if (!this[targetName]) {
      console.warn(`Target "${targetElement}" not found for "activation-wizard" controller`);
      return;
    }

    const targetContainer = this[targetName];

    // Determine if this is a mouseenter or mouseleave event
    const isHovering = event.type === 'mouseenter';

    if (isHovering) {
      // Show description
      targetContainer.classList.remove('d-none');
    } else {
      // Hide description
      setTimeout(() => {
        targetContainer.classList.add('d-none');
      }, 1000);
    }
  }


  redirectToRoleDescription() {
    window.open("https://aquifer.org/knowledge/user-administration/user-roles-permissions", "_blank")
  }

  redirectToSupport() {
    window.open("https://aquifer.org/knowledge/support/aquifer-support", "_blank")
  }

  redirectToGroupRolePage() {
    window.location.href = "/group_role_definition_users"
  }

  selectAdmin(input, name) {
    const selectedAdmins = input.parentElement.querySelector(".selected-admins")
    const badge = document.createElement("span")
    badge.className = "admin-badge"
    badge.innerHTML = `${name} <span class='remove-badge' data-action="click->activation-wizard#removeAdmin">X</span>`
    selectedAdmins.appendChild(badge)
    input.value = ""
    input.nextElementSibling.classList.add("d-none")
    this.checkRequiredFields()
  }

  removeAdmin(event) {
    const adminName = event.target.parentElement.textContent.replace(" X", "").trim()
    if (confirm(`Are you sure you want to remove ${adminName} from this course?`)) {
      event.target.parentElement.remove()
      this.checkRequiredFields()
    }
  }

  checkRequiredFields() {
    if (!this.hasContinueBtnTarget) {
      return
    }
    let allFilled = true
    document.querySelectorAll(".selected-admins").forEach(container => {
      if (container.children.length === 0) {
        allFilled = false
      }
    })
    this.continueBtnTarget.disabled = !allFilled
  }

  confirmChanges() {
    let addedAdmins = []
    document.querySelectorAll(".selected-admins").forEach(container => {
      const names = [...container.children].map(span => span.textContent.replace(" X", ""))
      addedAdmins.push(...names)
    })
    alert(`Added Administrators: ${addedAdmins.join(", ")}`)
  }

  showSuggestions(event) {
    const input = event.target
    const query = input.value.toLowerCase()
    const suggestionsBox = input.nextElementSibling
    const availableAdmins = ["John Doe", "Amy Smith", "David Rich", "Mike Jones", "Rick", "Sara K.", "Kia", "Nia", "Jack V", "Annie B"]

    suggestionsBox.innerHTML = ""
    if (query) {
      const matches = availableAdmins.filter(name => name.toLowerCase().includes(query))
      if (matches.length === 0) {
        suggestionsBox.innerHTML = "<div class='text-muted px-2'>No results found</div>"
      } else {
        matches.forEach(name => {
          const div = document.createElement("div")
          div.textContent = name
          div.classList.add("suggestion-item")
          div.onclick = () => this.selectAdmin(input, name)
          suggestionsBox.appendChild(div)
        })
      }
      suggestionsBox.classList.remove("d-none")
    } else {
      suggestionsBox.classList.add("d-none")
    }

    const style = document.createElement("style")
    style.innerHTML = `
      .suggestion-item {
        padding: 8px;
        cursor: pointer;
        background-color: white;
        border-bottom: 1px solid #ddd;
      }
      .suggestion-item:hover {
        background-color: #f8f9fa;
      }
      .suggestions {
        position: absolute;
        background: white;
        border: 1px solid #ddd;
        width: 100%;
        z-index: 10;
        max-height: 200px;
        overflow-y: auto;
      }
    `
    document.head.appendChild(style)
  }

  // === Newly merged methods ===

  handleOutsideClick = (event) => {
    const clickedInside = event.target.closest('.admin-tag-wrapper')
    if (!clickedInside) {
      document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
        dropdown.classList.add('hidden')
      })
    }
  }

  updateRoleUserCounter() {
    const rawMaxCount = this.hasMaximumCountValue ? this.maximumCountValue : $('.edit-user-role').data('activation-wizard-maximum-count-value');
    const numericMax = Number(rawMaxCount);
    const isUnlimited =
      rawMaxCount === null ||
      rawMaxCount === undefined ||
      rawMaxCount === '' ||
      rawMaxCount === 'null' ||
      Number.isNaN(numericMax) ||
      numericMax <= 0;
    const maxCount = isUnlimited ? Infinity : numericMax;
    const $select = $(".user-select2");
    const $keepAsItIs = $(".keep-as-it-is");
  
    const actualRecords = document.querySelectorAll(".nca-tbody .actual-record").length;
    const currentAdminRecords = document.querySelectorAll(".ca-tbody .current_admin").length;
    const counterElement = document.querySelector(".new_ca_filled_counter");
    if (counterElement) {
      counterElement.textContent = actualRecords;
    }

    const counterElement2 = document.querySelector(".new_ca_remaining_counter");
    if (counterElement2) {
      counterElement2.textContent = isUnlimited ? 'Unlimited' : maxCount - actualRecords;
    }

    if(actualRecords >= 1 && currentAdminRecords == 0) {
      setTimeout(() => {
        $('.apply_changes').prop("disabled", false);
      }, 100);
    } else {
      $('.apply_changes').prop("disabled", true);
    }
  
    if (!isUnlimited && actualRecords >= maxCount) {
      $select.prop("disabled", true);
      $select.next('.select2-container').css({
        'pointer-events': 'block',
        'cursor': 'not-allowed',
        'opacity': 0.6
      });
  
      $keepAsItIs.prop("disabled", true).css({
        'pointer-events': 'none',
        'cursor': 'not-allowed',
        'opacity': 0.4
      }).closest('li').css({ 'cursor': 'not-allowed' });
      // if ($('.ca-tbody').find('.current_admin').length == 0) {
      //   setTimeout(() => {
      //     $('.apply_changes').prop("disabled", false);
      //   }, 100);
      // } else {
      //   $('.apply_changes').prop("disabled", true);
      // }
    } else {
      $select.prop("disabled", false);
      $select.next('.select2-container').css({
        'pointer-events': 'all',
        'cursor': 'default',
        'opacity': 1
      });
  
      $keepAsItIs.prop("disabled", false).css({
        'pointer-events': 'all',
        'cursor': 'default',
        'opacity': 1
      }).closest('li').css({ 'cursor': 'default' });
      // $('.apply_changes').prop("disabled", true);
    }

    document.dispatchEvent(new CustomEvent("activation-wizard:role-counters-updated"))
  }

  initializeSelect2() {
    $('.apply_changes').prop("disabled", true); // Disable the apply changes button
    
    if (!$(".select2-tags").hasClass("select2-hidden-accessible")) {
      $(".select2-tags").select2({
        tags: true,
        tokenSeparators: [","],
        minimumResultsForSearch: Infinity,
        dropdownCssClass: "d-none",
        dropdownParent: $('.admin-selection'),
        placeholder: "Enter email addresses",
        createTag: function (params) {
          const email = params.term.trim()
          const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
          if (valid) {
            return { id: email, text: email, newTag: true }
          }
          return null
        },
        templateResult: () => null
      })
    }

    const $select = $(".user-select2");
    if (!$select.hasClass("select2-hidden-accessible")) {
      $select.select2({
        allowClear: true,
        multiple: true,
        width: 'resolve',
        tags: true,
        templateSelection: function (data) {
          return ''; // Hide selected tags
        },
        createTag: function (params) {
          const term = $.trim(params.term);
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
          if (emailRegex.test(term)) {
            // Get current user's email from data attribute
            const currentUserEmail = $select.data('current-user-email');
            const groupType = $select.data('group-type');
            const rolePage = $select.data('role-page');
            
            // Allow self-reassignment for np, pa, and nurse program types, or on IT Administrator page
            const allowedGroupTypes = ['np', 'pa', 'nurse'];
            const isItAdminPage = rolePage === 'IT Administrator';
            
            if (term.toLowerCase() === currentUserEmail?.toLowerCase() && 
                !allowedGroupTypes.includes(groupType) && 
                !isItAdminPage) {
              // Show error message
              const errorDiv = document.createElement('div');
              errorDiv.className = 'select2-error-message';
              errorDiv.textContent = 'You cannot re-assign yourself';
              errorDiv.style.color = 'red';
              errorDiv.style.padding = '5px';
              
              // Add error message to the dropdown
              const dropdown = document.querySelector('.select2-dropdown');
              if (dropdown) {
                dropdown.prepend(errorDiv);
                // Remove error message after 3 seconds
                setTimeout(() => errorDiv.remove(), 3000);
              }
              
              return null;
            }
            
            return {
              id: term,
              text: term,
              newTag: true // Mark it as a new tag
            };
          }
      
          // Reject the tag if not a valid email
          return null;
        }
      });
    }

    // Assume $select is already defined as the jQuery reference to your user-select2 element:
    const selectedUserIds = new Set();

    $select.off('select2:select').on('select2:select', (e) => {
      const selectedData = e.params.data;
      const adminId = selectedData.id;
      
      // Get data-role-page from the select element itself
      const role_page = $select.data('role-page')
      const lc = $select.data('lc') || null;
    
      if (selectedUserIds.has(adminId)) {
        console.warn("User already selected.");
        return;
      }
    
      // ✅ Email format validation for custom tags
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isEmail = emailRegex.test(adminId);
      if (!isEmail && isNaN(Number(adminId))) {
        console.warn("Invalid selection (not an ID or email).");
        return;
      }
    
      selectedUserIds.add(adminId);
    
      // Reset Select2 dropdown
      $select.val(null).trigger('change');
    
      const searchSection = document.querySelector(".search_user_edit_ca");
      if (!searchSection) {
        console.warn("Search section (.search_user_edit_ca) not found.");
        return;
      }
    
      const encodedId = encodeURIComponent(adminId);
    
      fetch(`/group_role_definition_users/${encodedId}/render_new_admin?fromSelect=true&role_page=${role_page}&lc=${lc}`, {
        headers: { 'Accept': 'text/vnd.turbo-stream.html' }
      })
        .then(response => response.text())
        .then(html => {
          searchSection.insertAdjacentHTML('afterend', html);
    
          this.updateRoleUserCounter();
    
          if (!isNaN(Number(adminId))) {
            const option = $select.find(`option[value='${adminId}']`);
            option.prop('disabled', true).addClass('d-none');
          }
        })
        .catch(error => {
          console.error("Failed to load CA admin row:", error);
        });
    });
    

  }
  
  keepAsItIs(event) {
    event.preventDefault();
  
    const row = event.target.closest("tr");
    const searchSection = document.querySelector(".search_user_edit_ca");
    const role_page = event.target.dataset.rolePage;
    const lc = event.target.dataset.lca || null;
  
    if (!row || !searchSection) {
      console.warn("Row or search section missing");
      return;
    }
  
    if (row.classList.contains("actual-record")) return;
  
    const adminId = row.dataset.adminId;
    if (!adminId) {
      console.warn("Admin ID missing on row");
      return;
    }
  
    // Remove the row from original position (optional if backend will re-render)
    row.remove();
  
    // Fetch the partial from the backend
    fetch(`/group_role_definition_users/${adminId}/render_new_admin?role_page=${role_page}&lc=${lc}`, {
      headers: { 'Accept': 'text/vnd.turbo-stream.html' }
    })
      .then(response => response.text())
      .then(html => {
        // Inject just after search section
        searchSection.insertAdjacentHTML('afterend', html);
        this.updateRoleUserCounter();
      })
      .catch(error => {
        console.error("Failed to load CA admin row:", error);
      });
  }

  reassignRole(event) {
    event.preventDefault();
  
    const adminId = event.currentTarget.dataset.adminId || event.currentTarget.dataset.userId;
    const role = event.currentTarget.dataset.role;
    const lca = event.currentTarget.dataset.lca || "false";
    const lc = event.currentTarget.dataset.lc || null;

    console.log("Reassigning CA:", role);
  
    if (!adminId) {
      console.warn("Missing data-admin-id on action trigger");
      return;
    }
  
    // Remove the existing row from wherever it is
    const row = event.currentTarget.closest("tr");
    row?.remove();
  
    // Fetch the partial from the backend and append to .rca-tbody
    fetch(`/group_role_definition_users/${adminId}/render_reassigned_admin?role=${encodeURIComponent(role)}&lca=${encodeURIComponent(lca)}&lc=${encodeURIComponent(lc)}`, {
      headers: { 'Accept': 'text/vnd.turbo-stream.html' }
    })
      .then(response => response.text())
      .then(html => {
        const rcaTbody = document.querySelector(".rca-tbody");
  
        if (rcaTbody) {
          rcaTbody.insertAdjacentHTML('beforeend', html);
        } else {
          console.warn(".rca-tbody not found");
        }
        this.updateRoleUserCounter();
      })
      .catch(error => {
        console.error("Failed to load reassigned admin row:", error);
      });
  }

  removeRole(event) {
    event.preventDefault();
  
    const adminId = event.currentTarget.dataset.adminId;
    const role = event.currentTarget.dataset.role;
    const lca = event.currentTarget.dataset.lca || "false";
    const lc = event.currentTarget.dataset.lc || null;

    console.log("Removing CA:", role);
  
    if (!adminId) {
      console.warn("Missing data-admin-id on action trigger");
      return;
    }
  
    // Remove the existing row from wherever it is
    const row = event.currentTarget.closest("tr");
    row?.remove();
  
    // Fetch the partial from the backend and append to .rca-tbody
    fetch(`/group_role_definition_users/${adminId}/render_reassigned_admin?role=${encodeURIComponent(role)}&lca=${encodeURIComponent(lca)}&removeRole=true&lc=${encodeURIComponent(lc)}`, {
      headers: { 'Accept': 'text/vnd.turbo-stream.html' }
    })
      .then(response => response.text())
      .then(html => {
        const rcaTbody = document.querySelector(".rca-tbody");
  
        if (rcaTbody) {
          rcaTbody.insertAdjacentHTML('beforeend', html);
        } else {
          console.warn(".rca-tbody not found");
        }
        this.updateRoleUserCounter();
      })
      .catch(error => {
        console.error("Failed to load reassigned admin row:", error);
      });
  }

  removeLcaFromCourse(event) {
    event.preventDefault();
  
    const adminId = event.currentTarget.dataset.adminId;
    const role = event.currentTarget.dataset.role;
    const lca = event.currentTarget.dataset.lca || "false";
    const lc = event.currentTarget.dataset.lc || null;
  
    if (!adminId) {
      console.warn("Missing data-admin-id on action trigger");
      return;
    }
  
    // Remove the existing row from wherever it is
    const row = event.currentTarget.closest("tr");
    row?.remove();
  
    // Fetch the partial from the backend and append to .rca-tbody
    fetch(`/group_role_definition_users/${adminId}/render_reassigned_admin?role=${encodeURIComponent(role)}&lca=${encodeURIComponent(lca)}&removeLcaFromCourse=true&lc=${encodeURIComponent(lc)}`, {
      headers: { 'Accept': 'text/vnd.turbo-stream.html' }
    })
      .then(response => response.text())
      .then(html => {
        const rcaTbody = document.querySelector(".rca-tbody");
  
        if (rcaTbody) {
          rcaTbody.insertAdjacentHTML('beforeend', html);
        } else {
          console.warn(".rca-tbody not found");
        }
        this.updateRoleUserCounter();
      })
      .catch(error => {
        console.error("Failed to load reassigned admin row:", error);
      });
  }

  moveToCurrentAdmin(event) {
    event.preventDefault();
  
    const adminId = event.currentTarget.dataset.adminId;
    const lc = event.currentTarget.dataset.lc || null;
  
    if (!adminId) {
      console.warn("Missing data-admin-id on button");
      return;
    }
    event.currentTarget.closest("tr")?.remove();
  
    fetch(`/group_role_definition_users/${adminId}/render_current_admin?lc=${lc}`, {
      headers: { 'Accept': 'text/vnd.turbo-stream.html' }
    })
      .then(response => response.text())
      .then(html => {
        const caTbody = document.querySelector(".ca-tbody");
  
        if (caTbody) {
          caTbody.insertAdjacentHTML('beforeend', html);
        } else {
          console.warn(".ca-tbody not found");
        }
        this.updateRoleUserCounter(); 
      })
      .catch(error => {
        console.error("Failed to load current admin row:", error);
      });
  }

  removeFromNewAdmin(event) {
    event.preventDefault();
  
    const adminId = event.currentTarget.dataset.adminId;
    const lc = event.currentTarget.dataset.lc || null;
  
    if (!adminId) {
      console.warn("Missing data-admin-id on button");
      return;
    }
  
    // Re-enable the option in the Select2 dropdown
    const $select = $(".user-select2");
    const option = $select.find(`option[value='${adminId}']`);
    option.prop('disabled', false); // Re-enable the option
    $select.trigger("change.select2"); // Refresh Select2 display
  
    // Remove the row from the UI
    const row = event.currentTarget.closest("tr");
    if (row) row.remove();
  
    this.updateRoleUserCounter();
  }
  
  submitChanges(event) {
    event.preventDefault(); 
  
    const currentAdmins = $('.ca-tbody .current_admin');
  
    if (currentAdmins.length > 0) {
      const message = "Current Admin(s) are still present.\n\n" +
                      "If you don't take any action on them,\n" +
                      "they will be removed after applying changes.\n\n" +
                      "Do you want to continue?";
  
      const confirmed = confirm(message);
  
      if (!confirmed) {
        return; // User chose not to proceed
      }
    }
  
    // Go ahead and submit the form
      const $form = $(event.target).closest('form');
      if ($form.length) {
        $form.submit();
      } else {
        console.error("Form not found.");
      }
  }
  

  optionSelected(event) {
    // event.detail is available if using a custom event;
    // but since we're using the native change event via Select2,
    // we can retrieve the selected options from the select.
    const selectedValues = $(event.currentTarget).val(); // an array of selected ids
    console.log("Option(s) selected:", selectedValues);
    
    // You can then fire a custom event if needed. For example:
    const customEvent = new CustomEvent('adminOptionSelected', {
      detail: { selectedIds: selectedValues },
      bubbles: true
    });
    // event.currentTarget.dispatchEvent(customEvent);
    
    // Optionally, you can add further logic here — like automatically triggering a CA addition process.
  }
  
}
